export default __webpack_public_path__ + "static/media/06AW2JUL66.45fb9dea.jpg";